
export const roles = {
  STAGE_LAB: 'stage_lab',
  ADMIN: 'admin',
} as const;

export type Roles = typeof roles[keyof typeof roles][];

export interface IUser {
    ref: string;
    _deleted: boolean;

    login: string;
    name: string;
    email?: string;
    password?: string;
    branch: string;
    isBlocked: boolean;
    history?:{
        created_at?: string;
        modified_at?: string;
    },
    roles?: Roles;
    price_type_cash?: string;
    alter_price_type?: string;
    isAlterPrice?: boolean;
    isAdmin: boolean;
  }

